module.exports = __webpack_public_path__ + "img/education-email-management.e3710543.webp";